import { useState, useEffect } from 'react';
import { useWebDesignedCart } from '../../contexts/WebDesignedCartContext';
import { getCartItems, type CartItem } from '../../services/cartService';
import { useCartDateLock } from './useCartDateLock';

/**
 * Invisible component that lives inside WebDesignedPortalContent (always mounted).
 * It keeps cart date locks in sync with the current shoppingCartData + cart items.
 */
export function CartDateLockManager() {
  const cart = useWebDesignedCart();
  const [cartItems, setCartItems] = useState<CartItem[]>(() => getCartItems());

  // Keep cartItems in sync with localStorage changes
  useEffect(() => {
    const onCartUpdated = () => setCartItems(getCartItems());
    window.addEventListener('cartUpdated', onCartUpdated);
    return () => window.removeEventListener('cartUpdated', onCartUpdated);
  }, []);

  useCartDateLock({
    shoppingCartData: cart?.shoppingCartData,
    cartItems,
  });

  return null;
}
